export default "__VITE_ASSET__pAYCl7JB__"